// Common file all the status

import * as React from "react";
import EdButton from "./../../generic/edButton";
import { Link } from "react-router-dom";
import "../../../assets/scss/components/login/generic/loginStatus.scss";

export interface LoginStatusProps {
	title?: string;
	subTitle?: string;
	message?: React.ReactChild;
	icon: string; // icon in the circle
	color: "blue" | "red" | "green"; // color of circle
	btnValue?: any; // value in the blue button. If present, then only blue button will show
	onButtonClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; // function to be called on blue button click
	linkTxt?: string; // show link/link-button only if this is present
	link?: string; // if this is present then show link otherwise show link-button
	onLinkClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; // function to be called on link button click
	className?: string; // extra class
}

const LoginStatus: React.FC<LoginStatusProps> = (props) => {
	return (
		<section className="login_sts_wrapper">
			<div className={"login_sts_container " + props.className}>
				{/* Circle */}
				<div className={"cir_icon " + props.color}>
					<i className={"edel_icon " + props.icon}></i>
				</div>

				{props.title && <h2 className={"title" + (props.color === "green" ? " green" : "")}>{props.title}</h2>}
				{props.subTitle && <h3 className={"sub_title" + (props.color === "blue" ? " cerulean" : "")}>{props.subTitle}</h3>}
				{props.message && <p className="sts_mess">{props.message}</p>}

				{/* Show blue button if btnValue is present */}
				{props.btnValue && (
					<div className="sts_btn">
						<EdButton className="login_btn" value={props.btnValue} btnTyp="primary" onClick={props.onButtonClick} />
					</div>
				)}

				{/* Show link button only if linkText is present */}
				{/* If link is present then make it link otherwise make it make button */}
				{props.linkTxt &&
					(props.link ? (
						<Link to={props.link} className="ed_button blue-link link_btn button">
							{props.linkTxt}
						</Link>
					) : (
						<EdButton className="link_btn button" value={props.linkTxt} btnTyp="blue-link" onClick={props.onLinkClick} />
					))}
			</div>
		</section>
	);
};

export default LoginStatus;
